// TRIL-239: detect the backend's IDV_REQUIRED login error and pull out the status/attempts
// so the login page can route the user to /verify-identity. Returns null for any other error.
import type { ApolloError } from '@apollo/client';

export interface IdvRequiredInfo {
  idvStatus: string;
  idvAttempts: number;
}

export function detectIdvRequired(error: Pick<ApolloError, 'graphQLErrors'>): IdvRequiredInfo | null {
  const ext = error.graphQLErrors?.[0]?.extensions as Record<string, unknown> | undefined;
  if (ext?.code !== 'IDV_REQUIRED') return null;
  return {
    idvStatus: typeof ext.idvStatus === 'string' ? ext.idvStatus : 'PENDING',
    idvAttempts: typeof ext.idvAttempts === 'number' ? ext.idvAttempts : 0,
  };
}
